// Valfri Sentry-initiering i webbläsaren, ENDAST när en riktig DSN finns.
//
// REACT_APP_SENTRY_DSN bakas in vid bygget via `define` i vite.config.ts. I
// produktion kommer värdet från serverns .env (compose skickar det som
// build-arg CLIENT_SENTRY_DSN till Dockerfile) eller från .env.production.
// Utan DSN laddas SDK:n aldrig och appen beter sig som förut. SDK:n importeras
// dynamiskt så att den inte tynger huvudbundlen. Ingen session replay.
const DSN = process.env.REACT_APP_SENTRY_DSN;

export const sentryEnabled = Boolean(DSN);

if (DSN) {
  (async () => {
    try {
      const Sentry = await import('@sentry/react');
      Sentry.init({
        dsn: DSN,
        environment: process.env.NODE_ENV,
        release: process.env.REACT_APP_VERSION || process.env.npm_package_version,
        tracesSampleRate: 0.1,
        integrations: [],
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0,
      });
      // Tag runtime
      Sentry.setTag('runtime', 'browser');
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('Sentry init failed', e);
    }
  })();
}
